exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only[data-v-061a5be5]{display:none !important}}@media (max-width: 1023px){.desktop-only[data-v-061a5be5]{display:none !important}}#home[data-v-061a5be5]{-webkit-box-sizing:border-box;box-sizing:border-box}.banner-grid[data-v-061a5be5]{margin:var(--spacer-base) 0}@media (min-width: 1024px){.banner-grid[data-v-061a5be5]{margin:var(--spacer-2xl) 0}}\n", ""]);

// exports
